const TAP_SLOP_PX = 12;
const QTY_TAP_SLOP_PX = 16;

function findScrollParent(el) {
  let node = el instanceof Element ? el : null;
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const oy = style.overflowY;
    if ((oy === "auto" || oy === "scroll" || oy === "overlay") && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

/** מונע ניווט / לחיצה כפולה אחרי מגע על פלוס־מינוס */
export function swallowClick(e) {
  e.preventDefault();
  e.stopPropagation();
}

/**
 * פלוס/מינוס: עכבר מיידי; מגע רץ ב־pointerup אם האצבע כמעט לא זזה.
 * לא מבטלים בגלל scroll — סגירת מקלדת / שינוי visualViewport
 * יורים scroll ומבטלים הוספה בחיפוש העליון.
 * preventDefault מונע לחיצת רוח (ghost click) על אלמנטים סמוכים — למשל שדה כמות.
 */
export function handleScrollSafePointerDown(e, action) {
  if (e.pointerType === "mouse" && e.button !== 0) return;
  e.preventDefault();
  e.stopPropagation();

  if (e.pointerType === "mouse") {
    action();
    return;
  }

  const startX = e.clientX;
  const startY = e.clientY;
  const pointerId = e.pointerId;

  const cleanup = () => {
    window.removeEventListener("pointerup", onUp, true);
    window.removeEventListener("pointercancel", onCancel, true);
  };

  const onUp = (up) => {
    if (up.pointerId !== pointerId) return;
    cleanup();
    if (Math.hypot(up.clientX - startX, up.clientY - startY) > TAP_SLOP_PX) return;
    action();
  };

  const onCancel = (ev) => {
    if (ev.pointerId !== pointerId) return;
    cleanup();
  };

  window.addEventListener("pointerup", onUp, true);
  window.addEventListener("pointercancel", onCancel, true);
}

/**
 * לחיצה על אזור בגלילה (מלאי בסניף): לא preventDefault — כדי שהאצבע תוכל לגלול.
 * פעולה רק אם זו לחיצה (עכבר) או מגע כמעט בלי תזוזה.
 */
export function handleTapWithoutScroll(e, action) {
  if (e.pointerType === "mouse" && e.button !== 0) return;

  if (e.pointerType === "mouse") {
    e.stopPropagation();
    action();
    return;
  }

  const startX = e.clientX;
  const startY = e.clientY;
  const pointerId = e.pointerId;

  const cleanup = () => {
    window.removeEventListener("pointerup", onUp, true);
    window.removeEventListener("pointercancel", onCancel, true);
  };

  const onUp = (up) => {
    if (up.pointerId !== pointerId) return;
    cleanup();
    if (Math.hypot(up.clientX - startX, up.clientY - startY) > TAP_SLOP_PX) return;
    up.preventDefault();
    up.stopPropagation();
    action();
  };

  const onCancel = (ev) => {
    if (ev.pointerId !== pointerId) return;
    cleanup();
  };

  window.addEventListener("pointerup", onUp, true);
  window.addEventListener("pointercancel", onCancel, true);
}

/**
 * פלוס/מינוס בתוך רשימה נגללת: לא חוסמים גלילה, ולא מוסיפים לסל אם האצבע זזה או הרשימה גללה.
 */
export function handleQtyTapAllowingScroll(e, action) {
  if (e.pointerType === "mouse" && e.button !== 0) return;
  e.stopPropagation();

  if (e.pointerType === "mouse") {
    action();
    return;
  }

  const startX = e.clientX;
  const startY = e.clientY;
  const pointerId = e.pointerId;
  const scrollParent = findScrollParent(e.currentTarget);
  const startScroll = scrollParent ? scrollParent.scrollTop : 0;

  const cleanup = () => {
    window.removeEventListener("pointerup", onUp, true);
    window.removeEventListener("pointercancel", onCancel, true);
    window.removeEventListener("pointermove", onMove, true);
    scrollParent?.removeEventListener("scroll", onScroll, true);
  };

  const onMove = (ev) => {
    if (ev.pointerId !== pointerId) return;
    if (Math.hypot(ev.clientX - startX, ev.clientY - startY) > QTY_TAP_SLOP_PX) cleanup();
  };

  const onScroll = () => {
    if (!scrollParent) return;
    if (Math.abs(scrollParent.scrollTop - startScroll) > 2) cleanup();
  };

  const onUp = (up) => {
    if (up.pointerId !== pointerId) return;
    cleanup();
    if (Math.hypot(up.clientX - startX, up.clientY - startY) > QTY_TAP_SLOP_PX) return;
    if (scrollParent && Math.abs(scrollParent.scrollTop - startScroll) > 2) return;
    up.preventDefault();
    up.stopPropagation();
    action();
  };

  const onCancel = (ev) => {
    if (ev.pointerId !== pointerId) return;
    cleanup();
  };

  window.addEventListener("pointerup", onUp, true);
  window.addEventListener("pointercancel", onCancel, true);
  window.addEventListener("pointermove", onMove, true);
  scrollParent?.addEventListener("scroll", onScroll, true);
}
